var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainPage"},[_c('headBar',{attrs:{"headbartype":"normal"}}),_vm._v(" "),_c('mainBody'),_vm._v(" "),_c('dialogSchedule'),_vm._v(" "),_c('dialogProject'),_vm._v(" "),_c('dialogMember')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e60ed174","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pagesPc/main/mainPage.vue
// module id = null
// module chunks = 